import request from '@/utils/request';

//自行推荐 包括禁止的列表
export function seledManualList(gainEid, data) {
    return request({
        url: `/gains/${gainEid}/mavin/seled/manuals`,
        method: 'get',
        params: data
    });
}

//可随机抽取的范围
export function listOptScope(gainEid, data) {
    return request({
        url: `/gains/${gainEid}/mavin/opt/scope`,
        method: 'get',
        params: data
    });
}

//临时禁用保存
export function outSave(gainEid, data) {
    data.useType = 2; //类型2表示禁用
    return optSave(gainEid, data);
}

export function optSave(gainEid, data) {
    return request({
        url: `/gains/${gainEid}/mavin/opt`,
        method: 'post',
        data: data
    });
}

export function optSearch(gainEid, data) {
    return request({
        url: `/gains/${gainEid}/mavin/opt`,
        method: 'get',
        params: data
    });
}

export function seledDelete(gainEid, encryMavinId) {
    return request({
        url: `/gains/${gainEid}/mavin/seled/${encryMavinId}`,
        method: 'delete'
    });
}

export function seledAttendList(gainEid, data) {
    return request({
        url: `/gains/${gainEid}/mavin/seled/attends`,
        method: 'get',
        params: data
    });
}

export function seledAttend(gainEid, mavinEid) {
    return request({
        url: `/gains/${gainEid}/mavin/seled/attend/${mavinEid}`,
        method: 'put'
    });
}

export function seledRands(gainEid, batchEid, data) {
    return request({
        url: `/gains/${gainEid}/mavin/seled/${batchEid}/rand`,
        method: 'get',
        params: data
    });
}